import React, { useState } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { RowSectionsProps } from './RowSections.types';
import { RowSectionsMapper } from './utils';

const RowSections = ({ rowSections }: RowSectionsProps) => {
    const [containerMinHeight, setContainerMinHeight] = useState<number>(400);

    return (
        <Stack
            marginBottom="10"
            marginTop="12"
            alignItems="center"
            width="100%"
            direction="column"
            gap="16"
            data-testid="row-sections"
            minHeight={{ lg: containerMinHeight }}
        >
            {rowSections.map((sectionName) => {
                const RowSection = RowSectionsMapper[sectionName];

                if (RowSection) {
                    const { lazyImport } = RowSection;

                    return (
                        <Container key={sectionName} width="100%">
                            <LazyComponent
                                lazyImport={lazyImport}
                                componentProps={{ sectionName, setContainerMinHeight }}
                            />
                        </Container>
                    );
                }

                return null;
            })}
        </Stack>
    );
};

export default RowSections;
